module.exports = __webpack_public_path__ + "img/Ribbon.6b9ed3b9.svg";